import React, { useState } from "react";
import Icon from "components/Elements/Icon/Icon.tsx";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useUser } from "contexts/userContext/userContext.js";
import EditSenderDetailsModal from "./EditSenderDetailsModal.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";

const SenderDetails = () => {
  const { getTextByKey } = useContent();
  const { getUserData } = useUser();
  const { setModal } = useModal();
  const userData = getUserData();
  const userFirstName = userData.UserFirstName ? userData.UserFirstName : "";
  const userLastName = userData.UserLastName ? userData.UserLastName : "";
  const nameToDisplay = userFirstName + " " + userLastName;
  const [displayName, setDisplayName] = useState(userData.DisplayNameOnGallery);
  const [displayEmailSubject, setDisplayEmailSubject] = useState(
    userData.DisplayEmailSubjectOnGallery
  );

  const openEditSenderDetailsModal = () => {
    setModal({
      modal: EditSenderDetailsModal,
      props: {
        displayName: displayName,
        setDisplayName: setDisplayName,
        displayEmailSubject: displayEmailSubject,
        setDisplayEmailSubject: setDisplayEmailSubject,
      },
    });
  };

  return (
    <div
      className={`sender-details-container ${
        !displayName && !displayEmailSubject ? "center-content" : ""
      }`}
    >
      <div className="sender-details-div">
        <div className="sender-details-content">
          <div
            className={`mail-subject-text ${
              !displayEmailSubject ? "hide" : ""
            }`}
          >
            {getTextByKey("subject-of-jumbomail")}
          </div>
          <div className={`mail-sender-text ${!displayName ? "hide" : ""}`}>
            {nameToDisplay}
          </div>
        </div>
        <div
          className="edit-container"
          onClick={() => openEditSenderDetailsModal()}
        >
          <Tooltip
            id={"edit-gallery-settings"}
            tooltipTextKey={"edit-gallery-settings-tooltip"}
            top
          >
            <Icon name="pencil-alt-solid" white />
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

export default SenderDetails;
